<template>
  <div>
    <div class="container-login">
      <div class="row">
        <div
          class="col-md-8 offset-md-2 container-form-login d-flex flex-column align-items-center justify-content-center"
        >
          <div class="container2-form-login">
            <div class="d-flex mb-3">
              <div class="d-flex flex-column">
                <h1 class="mb-0">Se connecter</h1>
                <p>Si vous avez déjà un compte</p>
              </div>
            </div>
            <div ref="part1" v-show="currentPart == 'part1'">
              <m-form-text
                placeholder="Identifiant"
                label-position="top"
                v-model="co_login"
                name="login"
                autocomplete
              ></m-form-text>
              <m-form-text
                type="password"
                placeholder="Mot de passe"
                label-position="top"
                v-model="co_password"
                autocomplete
                name="password"
              ></m-form-text>
              <div ref="alert" v-if="alert_txt">{{ alert_txt }}</div>
              <div class="d-flex flex-column links mt-3">
                <a class="pointer" @click="currentPart = 'part2'"
                  >Mot de passe oublié</a
                >
              </div>
              <div>
                <button @click="login()" class=" btn btn-primary btn-connexion">
                  Se connecter
                </button>
              </div>
            </div>

            <div ref="part2" v-show="currentPart == 'part2'">
              <m-form-text
                label="Identifiant ou Email"
                label-position="top"
                v-model="co_login"
                name="login"
                autocomplete
              ></m-form-text>
              <div ref="alert" v-if="alert_txt_part2">
                {{ alert_txt_part2 }}
              </div>
              <div class="d-flex flex-row justify-content-end mt-2">
                <button
                  @click="currentPart = 'part1'"
                  class="btn btn-secondary"
                >
                  Annuler
                </button>
                <button @click="sendPassword" class="btn btn-info ml-2">
                  Envoyer le mot de passe
                </button>
              </div>
            </div>

            <div ref="part3" v-show="currentPart == 'part3'">
              Vous allez recevoir un mail dans quelques instant, cliquez sur le
              lien pour mettre à jour votre mot de passe.
              <div>
                <!--  <button
                  color="black"
                  @click="currentPart = 'part1'"
                  class="btn btn-primary mt-2"
                >
                  Se connecter maintenant
                </button> -->
              </div>
            </div>

            <div ref="part4" v-show="currentPart == 'part4'">
              <div v-if="!alert_txt_part4">
                <m-form-text
                  type="password"
                  label="Nouveau mot de passe"
                  label-position="top"
                  v-model="co_password1"
                  autocomplete
                  name="password"
                ></m-form-text>
                <m-form-text
                  type="password"
                  label="Retaper votre mot de passe"
                  label-position="top"
                  v-model="co_password2"
                  autocomplete
                  name="password"
                ></m-form-text>
                <div class="d-flex flex-row justify-content-end mt-2">
                  <button
                    color="black"
                    @click="newpassword"
                    class="btn btn-info ml-auto "
                  >
                    Redéfinir le nouveau mot de passe
                  </button>
                </div>
              </div>
              <div ref="alert" v-if="alert_txt_part4">
                {{ alert_txt_part4 }}
              </div>
            </div>

            <div ref="part5" v-show="currentPart == 'part5'">
              C'est bon !
              <br />Votre nouveau mot de passe a été définit. <br />Vous pouvez
              maintenant vous connecter.
              <div>
                <button @click="currentPart = 'part1'" class="btn btn-primary">
                  Se connecter maintenant
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-message-dialog
      v-model="dialogErr"
      title="Erreur"
      :text="dialogErrTxt"
    ></m-message-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "login",
  components: {},
  data() {
    return {
      currentPart: "part1",
      societyName: "",
      logoUrl: "",
      co_login: "",
      co_password: "",
      co_password1: "",
      co_password2: "",
      alert_txt: "",
      alert_type: "warning",
      alert_txt_part2: "",
      alert_type_part2: "warning",
      alert_txt_part4: "",
      alert_type_part4: "warning",
      challenge_newpassword: "",
      co_id: "",
      dialogErr: false,
      dialogErrTxt: ""
    };
  },
  mounted() {
    //  this.$root.$children[0].hideMenus();
    //  this.$root.$children[0].resizeMainContainer();
    // this.loadAppData();
    if (this.$route.name == "resetpass") {
      this.currentPart = "part4";
      this.co_password1 = "";
      this.co_password2 = "";
      this.co_id = this.$route.params.co_id;
      this.checkchallenge(
        this.$route.params.co_id,
        this.$route.params.challenge
      );
    }
  },
  methods: {
    async newpassword() {
      //if (!this.challenge_newpassword) return;
      /*** vérification du mot de passe */
      if (!this.co_password1 || !this.co_password2) {
        this.dialogErrTxt = "Vous devez choisir un mot de passe";
        this.dialogErr = true;
      }
      if (this.co_password1 !== this.co_password2) {
        this.dialogErrTxt = "les mots de passe doivent être identiques";
        this.dialogErr = true;
      }
      if (!this.dialogErr) {
        let response = await this.$axios.post(
          this.$config.server_url +
            "/api/1.0/signin/forgetpassword/newpassword",
          {
            co_password: this.co_password1,
            co_id: this.co_id,
            challenge: this.challenge_newpassword
          }
        );
        if (response.data.err) {
          this.alert_txt_part4 = "Erreur";
        } else {
          this.currentPart = "part5";
        }
      }
    },
    async checkchallenge(co_id, challenge) {
      this.co_id = co_id;
      let response = await this.$axios.post(
        this.$config.server_url +
          "/api/1.0/signin/forgetpassword/checkchallenge",
        { co_id, challenge }
      );
      if (response.data.err) {
        this.alert_txt_part4 = "Erreur de challenge";
      } else {
        // this.currentPart = "part3";
        this.challenge_newpassword = response.data.data.challenge;
      }
    },
    async sendPassword() {
      let response = await this.$axios.post(
        this.$config.server_url + "/api/1.0/signin/forgetpassword",
        { co_login: this.co_login }
      );
      if (response.data.err) {
        this.alert_txt_part2 =
          "Nous n'avons pas pu retrouver votre identifiant";
      } else {
        this.currentPart = "part3";
      }
    },
    // async loadAppData() {
    //   let response = await this.$axios.get(
    //     this.$config.server_url + "/api/1.0/app-datas",
    //     {}
    //   );
    //   this.societyName = response.data.data.societyName;
    //   this.logoUrl = response.data.data.logoUrl;
    // },
    async login() {
      try {
        let response = await this.$axios.post(
          this.$config.server_url + "/web/1.0/signin",
          { co_login: this.co_login, co_password: this.co_password }
        );
        if (response.data.err) {
          //console.log("response.data.err", response.data.err);
          this.alert_txt = "Erreur de connexion";
          this.alert_type = "warning";
          this.dialogErrTxt =
            "Un problème est survenu. Votre identifiant ou votre mot de passe est incorrect.";
          this.dialogErr = true;
          /*           this.$store.dispatch(
            "showDialogError",
            "Un problème est survenu. Votre identifiant ou votre mot de passe est incorrect"
          ); */
          return;
        }
        this.alert_txt = "Vous êtes connecté";
        this.alert_type = "success";
        // this.$store.commit("set_token", response.data.accesstoken);
        // this.$store.commit("set_refreshtoken", response.data.refreshtoken);
        // this.$store.commit("set_user", response.data.data);
        this.$store.commit("set_connexion", {
          accesstoken: response.data.accesstoken,
          refreshtoken: response.data.refreshtoken,
          user: response.data.data,
          preferences: response.data.preferences
        });
        //   this.$root.$children[0].showMenus();
        this.$router.push("/");
      } catch (error) {
        console.error("error", error);
        this.alert_txt = "Erreur!!!";
        this.alert_type = "warning";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.img-fluid {
  width: 100%;
  height: auto;
}
.container2-form-login {
  width: 80%;
}
.links {
  align-items: flex-end;
}
</style>
